import { Component } from '@angular/core';
import { Router } from '@angular/router';
import { DbService } from '../service/db-service.service';

@Component({
  selector: 'app-thanksand-next-steps',
  imports: [],
  templateUrl: './thanksand-next-steps.component.html',
  styleUrl: './thanksand-next-steps.component.sass'
})
export class ThanksandNextStepsComponent {
state: any;
  constructor(private router: Router, public dbService: DbService) {} 
  
  addAttendees(){
    this.router.navigate(['inviteattendee'], { skipLocationChange: true});
  }
}
